/**
 * Whether a league/division document should be omitted from the public home screen.
 * Accepts boolean true and common string encodings (imports, manual edits).
 */
export function isLeagueHiddenFromHome(data) {
  if (!data || typeof data !== "object") return false;
  const v = data.HideFromHome;
  if (v === true) return true;
  if (v === 1) return true;
  if (typeof v === "string") {
    const s = v.trim().toLowerCase();
    return s === "true" || s === "1" || s === "yes";
  }
  return false;
}
